export const fmt = {
  currency: (n) => !n ? "TBD" : n >= 1_000_000 ? `$${(n / 1_000_000).toFixed(2)}M` : `$${Number(n).toLocaleString()}`,
  sf: (n) => `${Number(n).toLocaleString()} SF`,
  cap: (n) => !n ? "TBD" : `${Number(n).toFixed(2)}%`,
  pct:           (n) => (n != null && n !== 0) ? `${Number(n).toFixed(2)}%` : "—",
  multiple:      (n) => (n != null && n !== 0) ? `${Number(n).toFixed(2)}x` : "—",
  currencyOrDash:(n) => (n != null && n > 0)   ? (n >= 1_000_000 ? `$${(n/1_000_000).toFixed(2)}M` : `$${Number(n).toLocaleString()}`) : "—",
};

export function fmtBigMoney(n) {
  if (!n) return '$0';
  if (n >= 1_000_000_000) return `$${(n / 1_000_000_000).toFixed(1)}B`;
  if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(1)}M`;
  return `$${Math.round(n).toLocaleString()}`;
}
